import { withTranslation } from "react-i18next";
import {Avatar, Button, InputAdornment, makeStyles, Modal, TextField, Typography} from "@material-ui/core";
import { poolActions } from "../../../redux/actions/poolActions";
import React, {useEffect} from "react";
import { useDispatch, useSelector } from "react-redux";
const confirmIcon = 'https://demobanner.api-sands.com/Icons/swapIcon.png'

const UnlockAll = (props) => {
    const {
        onCancel: handleClose,
        modalVisible,
        values,
        t
    } = props;
    const useStyles = makeStyles((theme) => ({
        modal: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        paper: {
            position: 'absolute',
            width: 400,
            backgroundColor: theme.palette.background.paper,
            border: '2px solid #000',
            boxShadow: theme.shadows[5],
            padding: theme.spacing(2, 4, 3),
        }
    }));
    const classes = useStyles();
    const dispatch = useDispatch();
    const { token } = useSelector(state => state.auth)
    const { unlockables, myLiquidityPools,poolSigning } = useSelector(state => state.pool)

    useEffect(() => {
        dispatch(poolActions.getMyLiquidityPool(token))
        dispatch(poolActions.getUnlockable(token))
        return () => {
        }
    }, [])

    const resultViewBody = (
        <div style={{
            backgroundColor: '#09135F', borderRadius: 24, width: 480, overflow: 'hidden', outline: 0, display: 'flex', alignItems: 'center', flexDirection: 'column'
        }}>

            <Avatar src={confirmIcon} variant="square" style={{ height: 54*1.2, width: 77*1.2,marginTop:24 }} />

            <Typography style={{ fontSize: 16, fontWeight: 'bold', marginTop: 8, color: 'white' }}>
                {t('pool-confirm-title')}
            </Typography>
            <Typography style={{ fontSize: 12, fontWeight: 'bold', marginTop: -4, color: '#8FB9E1' }}>
                {t('pool-confirm-content')}
            </Typography>

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', width: '89%',marginTop:40,marginBottom: 40}}>
                <Typography style={{ fontSize: 14, color: 'white', fontWeight: 'bold' }}>
                    {t('pool-myLocker-unlockAll')}
                </Typography>
                <div style={{ display: 'block', alignItems: 'center' }}>
                    {unlockables.map(pool => {
                        let myPool = myLiquidityPools.find(item => item.poolId === pool.pid)
                        return(
                                <Typography style={{ justifyContent: 'flex-end', fontSize: 14, color: 'white', fontWeight: 'bold', marginRight: 8 }} >
                                    {pool.amount} {myPool? myPool.token1 :null}-{myPool ? myPool.token2 :null}-LP
                                </Typography>
                        )
                    })}
                </div>
            </div>

            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 8, width: '89%', marginBottom: 40 }}>
                <Typography style={{ fontSize: 12, fontWeight: 'bold', color: '#8FB9E1', textAlign: 'center' }}>
                    {t('pool-unlock-confirmAnnounce')}
                </Typography>
            </div>

        </div>
    );
    return (
        <Modal
            open={modalVisible}
            onClose={()=>{
                if (!poolSigning) {
                    handleClose()
                    dispatch(poolActions.clearUnlockable())
                }
            }}
            className={classes.modal}
        >
            {resultViewBody}
        </Modal>
    )
}
export default withTranslation()(UnlockAll);
